// Dependencies
import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import DoneIcon from '@mui/icons-material/Done';
import { useSidePanelMap, useGeocoder } from 'Core/hooks'
//import { EntitySelector } from 'Components'
import { NotificationManager } from 'Components/Notifications';
import EntitySelector from 'Modules/.common/components/EntitySelector';
import EditableLabel from 'Components/EditableLabel';
import { InputDate } from 'Components';
import moment from 'moment';
import { Form } from 'Components/uiControls/Form'



const MainView = () => {
	const form = Form.useForm()

	useEffect(() => {
		form.setValues({ rc: "Hola" })
	})


	return (
		<div>
			<Form
				ref={form.ref}
				onSubmit={(values, invalidValues) => { console.log("onSubmit", values, invalidValues) }}
				onValidSumit={(values) => { console.log("onValidSumit", values) }}
			>
				<Form.Item name="option" label="select" rules={[{ required: true, message: "obligatorio" }]}>
					<Form.RC />
				</Form.Item>
				<button type="submit" className="btn btn-primary" onClick={() => { form.submit() }}>Sign in</button>
			</Form>
			Test of version CloudFront with Shield 3
			<button onClick={() => { form.resetValues() }}>clear</button>
		</div>
	);
};

export default injectIntl(MainView);
